<template>
    <DModal
        :show="showModal"
        :title="__('customers.customers.create_cloudpit_customer.title')"
        @update:show="$emit('update:showModal', $event)"
        @close="closeCreateCloudpitCustomerModal"
    >
        <template #default>
            <div
                v-if="cloudpitStatus === 'loading'"
                class="loading"
            >
                <DIcon
                    name="loading"
                    :size="32"
                />
            </div>
            <p
                v-if="cloudpitStatus === true"
                style="padding: 0 25px; text-align: center;"
            >
                <DIcon
                    name="account-check"
                    :size="32"
                /><br><br>

                {{ __('customers.customers.create_cloudpit_customer.creation_successful') }}
            </p>
            <p
                v-if="cloudpitStatus === 'failed' || cloudpitStatus === false"
                style="padding: 0 25px; text-align: center;"
            >
                <DIcon
                    name="account-cancel"
                    :size="32"
                /><br><br>

                {{ __('customers.customers.create_cloudpit_customer.creation_error') }}
            </p>
            <p
                v-if="cloudpitStatus === ''"
                style="padding: 0 25px; text-align: center;"
            >
                <DIcon
                    name="account-question"
                    :size="32"
                /><br><br>

                {{ __('customers.customers.create_cloudpit_customer.explaination') }}
            </p>
            <p style="padding: 0 45px; text-align: center;">
                <DFormCheck
                    id="send_mail"
                    v-model="sendMail"
                    :label="__('customers.customers.create_cloudpit_customer.inform_via_mail') "
                    inline
                />
            </p>
        </template>
        <template #actions>
            <DButton
                v-if="cloudpitStatus === ''"
                :label="__('customers.customers.create_cloudpit_customer.create')"
                @click="createCloudpitCustomer"
            />
            <DButton
                v-if="cloudpitStatus === true"
                icon="lan-connect"
                :label="__('customers.customers.sso')"
                @click="loginViaSSO"
            />
        </template>
    </DModal>
</template>

<script>

export default {
    name: 'CreateCloudPitCustomerModal',
    props: {
        customer: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showModal: {
            type: Boolean,
            default: false
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            sendMail: false,
            cloudpitStatus: ''
        }
    },
    watch: {
        showModal: {
            handler () {
                this.cloudpitStatus = ''
            }
        }
    },
    methods: {
        async generateSSOLink () {
            const self = this
            self.ssoLink = null
            try {
                const response = await window.axios.get(this.$route('customers.customers.sso', this.customer.id))
                self.loginStatus = ''
                self.ssoLink = response.data.url
            } catch (e) {
                self.loginStatus = 'failed'
            }
        },
        async createCloudpitCustomer () {
            const self = this

            self.cloudpitStatus = 'loading'

            try {
                const response = await window.axios.get(this.$route('customers.customers.create-cloudpit-customer', { customer: this.customer.id, sendMail: this.sendMail }))
                self.cloudpitStatus = response.data.result
            } catch (e) {
                self.cloudpitStatus = 'failed'
            }
        },
        login () {
            window.open(this.ssoLink, '_blank').focus()
        },
        async loginViaSSO () {
            await this.generateSSOLink()
            this.login()
        },
        closeCreateCloudpitCustomerModal () {
            this.$emit('close-modal')

            if (this.cloudpitStatus === true) {
                this.$inertia.reload()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.loading {
    padding: 40px 0;
    display: flex;
    justify-content: center;

    & .mdi {
      animation: loadingAnim 0.4s infinite linear;
    }
}
@keyframes loadingAnim {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>
